import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from '../types';

export const PayPalIcon: FC<IconProps> = ({ width = 32, height = 32 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={[0, 0, width, height].join(' ')}
      fill="none"
      stroke="none"
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2177_148917)">
        <path
          d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
          fill="white"
        />
        <path
          d="M20.3902 9.88658C19.7234 9.12662 18.5182 8.80078 16.9762 8.80078H12.5011C12.3486 8.80078 12.201 8.85522 12.085 8.95426C11.969 9.05334 11.8921 9.19054 11.8682 9.34122L10.0048 21.1591C9.9678 21.3921 10.1482 21.6031 10.3844 21.6031H13.1472L13.8411 17.2021L13.8195 17.3399C13.869 17.0289 14.135 16.7994 14.4501 16.7994H15.763C18.3421 16.7994 20.3616 15.7518 20.9515 12.7214C20.969 12.6318 20.9842 12.5446 20.9973 12.4593C20.9228 12.4199 20.9228 12.4199 20.9973 12.4593C21.1729 11.3393 20.9961 10.5769 20.3902 9.88658Z"
          fill="#27346A"
        />
        <path
          d="M14.8982 12.0559C14.9738 12.0199 15.0564 12.0013 15.14 12.0013H18.6484C19.0639 12.0013 19.4514 12.0283 19.8055 12.0853C19.9046 12.1011 20.0031 12.12 20.101 12.1419C20.2398 12.1725 20.377 12.21 20.5121 12.2542C20.6862 12.3123 20.8483 12.3801 20.9973 12.4593C21.1729 11.3389 20.9961 10.5769 20.3902 9.88658C19.7231 9.12662 18.5182 8.80078 16.9762 8.80078H12.5008C12.1856 8.80078 11.9176 9.03018 11.8682 9.34122L10.0048 21.1586C9.9678 21.3921 10.1482 21.6028 10.3841 21.6028H13.1472L14.5868 12.4741C14.6009 12.3843 14.6366 12.2994 14.6909 12.2265C14.7452 12.1537 14.8163 12.0951 14.8982 12.0559Z"
          fill="#27346A"
        />
        <path
          d="M20.9515 12.7191C20.3616 15.7491 18.3422 16.7971 15.763 16.7971H14.4498C14.1347 16.7971 13.8686 17.0266 13.8197 17.3376L12.9565 22.8097C12.9242 23.0137 13.0819 23.1985 13.2883 23.1985H15.6172C15.7506 23.1984 15.8797 23.1508 15.9811 23.0642C16.0825 22.9775 16.1497 22.8575 16.1705 22.7257L16.1932 22.607L16.6321 19.8251L16.6604 19.6714C16.6813 19.5396 16.7485 19.4196 16.8499 19.333C16.9513 19.2463 17.0803 19.1986 17.2137 19.1986H17.5623C19.8183 19.1986 21.5849 18.282 22.1011 15.6312C22.3166 14.5235 22.2051 13.5986 21.6351 12.949C21.4622 12.7522 21.2475 12.5897 20.9973 12.457C20.9838 12.5427 20.9691 12.6295 20.9515 12.7191Z"
          fill="#2790C3"
        />
        <path
          d="M20.3799 12.2119C20.2879 12.1851 20.1951 12.1613 20.1015 12.1406C20.0035 12.1191 19.905 12.1004 19.8059 12.0844C19.4514 12.0271 19.0642 12 18.6484 12H15.1404C15.0567 11.9998 14.974 12.0186 14.8986 12.055C14.8166 12.0941 14.7454 12.1526 14.6911 12.2255C14.6368 12.2984 14.6011 12.3834 14.5871 12.4732L13.8415 17.2009L13.8199 17.3387C13.869 17.0276 14.1351 16.7982 14.4501 16.7982H15.7634C18.3425 16.7982 20.362 15.7506 20.9519 12.7202C20.9695 12.6305 20.9842 12.5437 20.9977 12.4581C20.8483 12.3792 20.6866 12.3111 20.5125 12.2533C20.4686 12.2388 20.4244 12.225 20.3799 12.2119"
          fill="#1F264F"
        />
      </g>
      <defs>
        <clipPath id="clip0_2177_148917">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
